import { ActionIcon, Popover } from '@mantine/core';
import * as icons from '@sloyd/icons';
import classnames from 'classnames';
import { useState } from 'react';
import { categories } from './IconCategories.data';
import { Count, Item, Items, Title, Wrapper } from './IconCategories.style';

export type IconCategoriesProps = {
  value?: string;
  onChange: (value: string) => void;
};

export function IconCategories(props: IconCategoriesProps) {
  const { value = 'all' } = props;
  const [popoverOpened, setPopoverOpened] = useState(false);

  const current = categories.find((category) => category.id === value) ?? { icon: '' };

  function onChange(value: string) {
    props.onChange(value);
    setPopoverOpened(false);
  }

  // Render a single category as a Menu.Item
  function renderCategory(category: Json) {
    const { icon, title, count } = category;
    const Icon = (icons as any)[icon];

    const className = classnames({
      active: value === category.id,
    });

    return (
      <Item key={category.id} className={className} onClick={() => onChange(category.id)}>
        {Icon && <Icon size={24} />}
        <Title>{title}</Title>
        <Count>({count.toLocaleString()})</Count>
      </Item>
    );
  }

  // Render all categories with 4-column layout
  function renderCategories() {
    return (
      <Items className='menu-grid'>{categories.map((category) => renderCategory(category))}</Items>
    );
  }

  const Cmp = (icons as any)[current.icon];

  return (
    <Wrapper className='IconCategories-wrapper' data-testid='IconCategories-wrapper'>
      <Popover opened={popoverOpened} offset={15} withArrow position='right'>
        <Popover.Target>
          <ActionIcon
            onClick={() => setPopoverOpened((o) => !o)}
            variant='subtle'
            color='dark'
            radius='xs'
          >
            {Cmp && <Cmp size={20} />}
          </ActionIcon>
        </Popover.Target>
        <Popover.Dropdown>{renderCategories()}</Popover.Dropdown>
      </Popover>
    </Wrapper>
  );
}

export default IconCategories;
